import { useMutation } from '@tanstack/react-query';

import type {
  BookingGroupScheduleMutationResponse,
  DeleteBookingGroupScheduleData,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useDeleteBookingGroupScheduleMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: DeleteBookingGroupScheduleData;
    }) =>
      HttpClient.request<BookingGroupScheduleMutationResponse>({
        method: 'DELETE',
        url: params.url,
        params: params.data,
      }),
  });
